import appConstants from '../../constants';
import fetchService from '../fetchService';

const SERVICE_URL = `${appConstants.SERVICE_BASE_URL}${appConstants.SERVICE_REQUEST_SAVE_USER_PARTNER_URL}`;

export default async function saveUserPartnerService(userId, partnerBeGeoId, partnerSiteId) {
  let fetchedDataObject =
    await fetchService(
      'saveUserPartner',
      SERVICE_URL,
      {
        ...appConstants.SERVICE_REQUEST_SAVE_USER_PARTNER_CONFIG,
        body: JSON.stringify(
          {
            ccoId: userId,
            begeoId: partnerBeGeoId,
            siteId: partnerSiteId,
            actionDesc: 'ADDED'
          })
      },
      true
    );
  return !fetchedDataObject.success ?
    {
      hasError: true,
      errorMessage: fetchedDataObject.statusMessage
    } :
    {
      hasError: false,
      errorMessage: null
    };
}
